import React, { useReducer } from 'react'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import { FormRow, FormCol } from 'style/styled'
import { CashRegisters, filterReducer, DatePeriod } from '../filterFragments'
import { ContentBlock, ExpandableBlocks } from 'components/ContentBlock'
import { CardsRow, CardCol } from '../filterFragments/styled'
import { DateTimePicker } from 'components/forms'
import { listUsers } from 'sections/user/gql'
import Divider from 'components/Divider'
import { Col } from 'react-flexbox-grid'
import Button from 'components/Button'
import FilterCardRemote from 'components/FilterCard/FilterCardRemote'
import { listCashRegisters } from 'gql/query'
import { useQuery } from 'components/graphql'

const Filter = ({ handleSetFilter }) => {
	const [t] = useTranslation()
	const { data } = useQuery(listCashRegisters, { fetchPolicy: 'cache-first' })
	const [filterPrepare, dispatchFilter] = useReducer(filterReducer, {
		from: moment().utc().startOf('day').toISOString(),
		to: moment().utc().endOf('day').toISOString(),

		timeStart: moment().utc().startOf('day').format('HH:mm:ss.SSSZ'),
		timeEnd: moment().utc().endOf('day').format('HH:mm:ss.SSSZ'),

		cashRegisterIds: data?.listCashRegisters?.map(({ id }) => id) || [],
		userIds: []
	})

	const { from, to, timeStart, timeEnd, cashRegisterIds, userIds } = filterPrepare
	const isDatePeriod = moment(to).diff(moment(from), 'days') >= 1
	const dateLabel = t('statistic_section.strings.date')

	return (
		<ContentBlock blockId='0' startExpanded={!!'called'} label={t('common.strings.settings')}>
			<ExpandableBlocks nested>
				<FormRow>
					<FormCol narrow={!isDatePeriod}>
						<DatePeriod
							value={{ fromDateTime: from, toDateTime: to }}
							onChange={value => dispatchFilter({ value, type: 'dateTime' })}
							label={dateLabel}
							labelPeriod={{
								from: `${dateLabel} ${t('common.strings.from').toLowerCase()}`,
								to: `${dateLabel} ${t('common.strings.to').toLowerCase()}`
							}}
						/>
					</FormCol>
					<FormCol xs>
						<DateTimePicker
							noForm
							value={{ from: timeStart, to: timeEnd }}
							onChange={value => dispatchFilter({ value, type: 'timePeriod' })}
							picker='time'
							interval
							label={{ from: t('common.strings.from'), to: t('common.strings.to') }}
							addDateToTime={false}
						/>
					</FormCol>
				</FormRow>
			</ExpandableBlocks>
			<div>
				<ExpandableBlocks nested>
					<ContentBlock startExpanded label={t('common.buttons.filter')}>
						<CardsRow>
							<CardCol>
								<CashRegisters
									value={cashRegisterIds}
									onChange={value => dispatchFilter({ value, type: 'cashRegisterIds' })}
								/>
							</CardCol>
							<CardCol>
								<FilterCardRemote
									listQuery={listUsers}
									label={t('statistic_section.strings.user')}
									allItemsLabel={t('statistic_section.strings.all_users')}
									value={userIds}
									onChange={value => dispatchFilter({ value, type: 'userIds' })}
									withSearch={true}
								/>
							</CardCol>
						</CardsRow>
					</ContentBlock>
				</ExpandableBlocks>
			</div>
			<Divider />
			<Col type='row'>
				<Button text={t('common.buttons.calculate')} onClick={() => handleSetFilter(filterPrepare)}/>
			</Col>
		</ContentBlock>
	)
}

export default Filter
